import React from "react";
import { useLang } from "../context/LanguageContext";
import { Languages } from "lucide-react";

export default function LanguageSwitch({ className = "" }) {
  const { lang, toggle } = useLang();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="language-switch"
      className={`inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium transition-colors hover:bg-secondary ${className}`}
    >
      <Languages className="h-4 w-4" />
      {lang === "en" ? "کوردی" : "English"}
    </button>
  );
}
